import servicio from '@/services/servicio-base'

const servicioDetalleProducto = {}

servicioDetalleProducto.detalleProducto = function(codArticulo){
    return servicio.get(`/detalle-producto/producto/${codArticulo}`)
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}

servicioDetalleProducto.productosSustitutos = function(codArticulo){
    return servicio.get(`/detalle-producto/sustitutos/${codArticulo}`)
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}

servicioDetalleProducto.productosPaisOrigen = function(codArticulo){
    return servicio.get(`/detalle-producto/pais-origen/${codArticulo}`)
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}

servicioDetalleProducto.validarClickPublicidad = params =>{
    return servicio.post('/detalle-producto/producto-click-publicidad',params)
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}
export default servicioDetalleProducto